import React from 'react';
import StepFinder from '../map/StepFinder';

const StepFinderSelect = ({ id, hikeId, className, input, onChange, isDisabled, showDistance, isClearable, placeholder, fromStepId, direction }) =>
    <StepFinder
        id={id}
        hikeId={hikeId}
        isDisabled={isDisabled}
        isClearable={isClearable}
        showDistance={showDistance}
        direction={direction}
        placeholder={placeholder}
        onBlur={() => input.onBlur(input.value)}
        fromStepId={fromStepId}
        onChange={(step)=>{
            onChange(step);
            input.onChange(step)
        }}
        className={className}
        value={input.value}
    />
;

export default StepFinderSelect;
